define((require) => {
    "use strict";

    const FontLoader    = require("shared/util/FontLoader");
    const ImprovedView  = require("editor/zbone/ImprovedView");
    const template      = require("ui/viewer/SceneThumbnailViewer.tpl");
    const ImprovedModel = require("shared/zbone/ImprovedModel");
    const RestApi       = require("shared/services/RestApi");
    const $             = require("jquery");
    /**
     * View model for the scene thumbnail.
     *
     * @class ExperienceThumbnailViewModel
     * @constructor
     */
    const ExperienceThumbnailViewModel = ImprovedModel.extend("ExperienceThumbnailViewModel", {

        url() {
            return RestApi.pathToCollectionOnResource(RestApi.Collections.EXPERIENCES, this.get("id"), "thumbnail");
        },
        defaults: {
            id: "",
            html: ""
        }
    });

    /**
     * A scene thumbnail "viewer". Renders a scene with some defined maximum size.
     *
     * @class ExperienceThumbnailViewer
     * @constructor
     *
     * @cfg {ExperienceModel} experience The parent experience.
     * @cfg {Object} [maxDimensions] Optional max dimensions to scale the viewer to. If specified, must contain width, height, or both.
     */
    return ImprovedView.extend({

        className: "scene-thumbnail experience-container",


        template,

        ui: {
            sceneWrapper: ".scene-wrapper-inner",
            sceneWrapperOuter: ".scene-wrapper-outer"
        },

        _experience: null,
        _sceneZeroModel: null,
        _maxDimensions: null,
        _showStaticScenes: null,
        _isPushed: false,

        initialize() {
            this._experience = this.options.experience;
            this._isPushed = (this._experience.get("pushedAt") > 0);
            this._sceneZeroModel = this.options.model;
            this._showStaticScenes = this.options.showStaticScenes;
            this._maxDimensions = this.options.maxDimensions;
        },

        /**
         * Used only when we fail for some reason talking to CNC to get html of the pushed experience.
         * This viewer generates a full experience viewer and is the final viewer fallback before stating we can't get
         * a thumbnail.  If the experience hasn't been pushed we will fall back further to putting a message of:
         * "Thumbnail Unavailable" in place of the thumbnail.
         * @private
         */
        _fallbackThumbnail() {
            // old default thumbnail code.
            const defaultThumbnail = document.createElement("DIV");
            defaultThumbnail.innerHTML += "Thumbnail <br> Unavailable";
            defaultThumbnail.style.cssText = "border: none;text-align: center;color: @grey04;font-size: 18px;font-weight: 800; cursor: default";
            this.$el.find(this.ui.sceneWrapper).append(defaultThumbnail);
        },

        onRender() {
            this._experience.fetch().then((experience) => {
                if (!this.model) {
                    this._fallbackThumbnail();
                } else {
                    FontLoader.loadSceneFonts(this.model, experience)
                        .always(() => {
                            if (this.isClosed) {
                                return;
                            }
                            const model = new ExperienceThumbnailViewModel({id: this._experience.get("id")});
                            const self = this;
                            model.fetch({silent: true}).then(() => {
                                const html = model.get("html");

                                if (html === "" || !this.model) {
                                    self._fallbackThumbnail();
                                } else {
                                    const scaledDimensions = self._experience.getDimensions(self.options.maxDimensions);
                                    const padX = ((scaledDimensions.width * scaledDimensions.scale) - scaledDimensions.width) / 2;
                                    const padY = ((scaledDimensions.height * scaledDimensions.scale) - scaledDimensions.height) / 2;

                                    const sceneWrapperOuterElement = self.$el.find(self.ui.sceneWrapperOuter);
                                    $(sceneWrapperOuterElement).css({
                                        overflow: "hidden"
                                    });

                                    const pointerDiv = document.createElement("div");
                                    $(pointerDiv).css({
                                        cursor: "pointer",
                                        width: self.options.maxDimensions.width,
                                        height: self.options.maxDimensions.height,
                                        top: `${0}px`,
                                        "z-index": 100,
                                        position: "absolute"
                                    });
                                    sceneWrapperOuterElement.append(pointerDiv);

                                    const thumbnail = model.get("html");

                                    const scenewrapperElement = self.$el.find(self.ui.sceneWrapper);

                                    scenewrapperElement.append(thumbnail);

                                    $(scenewrapperElement).css({
                                        top: `${padY}px`,
                                        left: `${padX}px`,
                                        transform: `scale(${scaledDimensions.scale},${scaledDimensions.scale}) `,
                                        width: scaledDimensions.width,
                                        height: scaledDimensions.height
                                    });

                                    let i = 0;
                                    const iframes = $("iframe", self.el);
                                    for (i = 0; i < iframes.length; i++) {
                                        const parent = $(iframes[i].parentNode);
                                        const iheight = parent.height();
                                        const iwidth = parent.width();
                                        const iframeReplace = document.createElement("DIV");
                                        $(iframeReplace).css({
                                            height: iheight,
                                            width: iwidth,
                                            "background-color": "#d0a1be"
                                        });
                                        iframes[i].replaceWith(iframeReplace);
                                    }
                                }
                            }).fail(() => {
                                self._fallbackThumbnail();
                            });
                        });
                }
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/viewer/ExperienceThumbnailViewer.js